
const translations = {
    location : {
        "Id": "Nr",
        "Name": "Naam",
        "CompletionDate": "Opleveringsdatum",
        "Street": "Straat",
        "Number": "Huisnr",
        "PostalCode": "Postcode",
        "Latitude": "Breedtegraad (lat)",
        "Longitude": "Lengtegraad (long)",
        "City": "Plaats",
        "Organisation": "Organisatie",
        "CustomerNr": "Klantnr",
        "OrganisationType": "Organisatietype",
        "Led": "Led",
        "LedOutside": "LedV",
        "LedReduction": "Ledbesparing",
        "Reach": "Bereik"
    },
    inverter: {
        "id": "Omvormer Nr",
        "name": "Locatie",
        "type": "Omvormer",
        "address": "Adres",
        "active": "In gebruik",
        "panels": "Aantal panelen",
        "wp": "WP per paneel ",
        "location_id": "Locatie Nr",
        "city_name": "Plaats",
        "yield_factor": "Opbrengstfactor"
    },
    logger: {
        "id": "Logger Nr",
        "name": "Locatie",
        "sim": "Simkaart",
        "powerplug": "PowerPlug internet",
        "utp": "UTP aansluiting",
        "wifi": "Wifi",
        "ip": "Sim IP Adres",
        "last_update": "Laatste update",
        "version": "Software versie",
        "description": "Beschrijving",
    }
}

module.exports = {
    location: translations.location,
    inverter: translations.inverter,
    logger: translations.logger,
};



// WEBPACK FOOTER //
// ./src/constants/translations.js